import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const categoryApi = createApi({
  reducerPath: "category",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchCategories: builder.query({
        providesTags: () => ["categories"],
        query: (pagination) => {
          return {
            url: pagination
              ? `category?page=${pagination.page}&limit=${pagination.limit}`
              : "category",
            method: "GET",
          };
        },
      }),
      postCategory: builder.mutation({
        invalidatesTags: () => ["categories"],
        query: (category) => {
          return {
            url: "category/",
            method: category.id !== 0 ? "PUT" : "POST",
            body: category,
          };
        },
      }),
      deleteCategory: builder.mutation({
        invalidatesTags: () => ["categories"],
        query: (id) => {
          return {
            url: `category?id=${id}`,
            method: "DELETE",
          };
        },
      }),
    };
  },
});

export const { useFetchCategoriesQuery, usePostCategoryMutation, useDeleteCategoryMutation } = categoryApi;
export { categoryApi };
